import React, { useEffect, useState } from "react";
import Sidebar from "../Sidebar";
import { useNavigate, useParams } from "react-router-dom";
import { getMaterial } from "../../utils/actions/allactions";
import { toast } from "react-toastify";
import { processType } from "../../utils/constant";
import tickwhite from "../../images/tick-white.svg";
import { Modal as AntModal } from "antd";

import uploadImage from "../../images/upload.svg";
import moment, { suppressDeprecationWarnings } from "moment";
import downloadFileFromS3, {
  extractURLAndEncodedFilename,
  numberInputOnWheelPreventChange,
} from "../../utils/helper";
import {
  createSupplierCompany,
  getSupplierById,
  updateSupplierCompany,
} from "../../utils/actions/supplierActions";
import QRTrackingHoverInfo from "../../components/QRTrackingHoverInfo/QRTrackingHoverInfo";
import { Modal, Accordion } from "react-bootstrap";
import PhoneInput from "react-phone-input-2";
import useDocumentTitle from "../../utils/useDocumentTitle";
import { DeleteIcon, DownloadIcon } from "../../components/Icons";
import { fetchOrganzationDetails } from "../../api/customer/masters/commonMastersApi";

const AddSupplierCompany = () => {
  const navigate = useNavigate();
  useDocumentTitle("Add/Edit Supplier Company");
  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  // Inside component state:
  const [inputError, setInputError] = useState("");

  const [material, setMaterial] = useState([]);
  const [subMaterial, setSubMaterial] = useState([]);
  const [partmarking, setPartMarking] = useState([]);
  const [surfaceFinish, setSurfaceFinish] = useState([]);
  const [organizationDetails, setOrganizationDetails] = useState();
  const [surfaceTreatment, setSurfaceTreatment] = useState([]);
  const [tolerance, setTolerance] = useState([]);
  const [layer, setLayer] = useState([]);
  const [filteredSubmaterial, setFilteredSubmaterial] = useState([]);
  const [filteredSurfaceTreatment, setFiltertedSurfaceTreatment] = useState([]);
  const [emailInput, setEmailInput] = useState('');
  const [selectedLabel, setSelectedLabel] = useState('All');
  const [emailList, setEmailList] = useState([]);



  const [email, setEmail] = useState("");
  const token = localStorage.getItem("Token");
  let documentObject = {
    documentName: "",
    uploadedFile: "",
    dateUploaded: new Date(),
    nextUpdatedByDate: "",
  };
  const { _id } = useParams();
  function isValidEmail(email) {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  }
  const [error, setError] = useState("");

  useEffect(() => {
    fetchData();
  }, []);

  const handleEmailDelete = (index) => {
    setEmailList((pre) => pre.filter((_, idx) => idx != index));
  }

  const fetchData = async () => {


    const organizationResponse = await fetchOrganzationDetails();
    if (organizationResponse.success) {
      const { data } = organizationResponse;
      console.log("Org Data :", data);
      setOrganizationDetails(data);
      handleSupplierValueChange(
        "supplierRefId",
        data?.supplierPrefix + '-' + data?.supplierCounter
      );
    }



    let supplierResponse;
    if (_id) {
      supplierResponse = await getSupplierById(_id, token);
      console.log("Email Response :", supplierResponse);
      if (supplierResponse.status) {
        setSupplierValue(supplierResponse.data);
        if (supplierResponse?.data?.emailList) {

          setEmailList(supplierResponse?.data?.emailList)
        }
      }
      if (supplierResponse?.data?.materialsAvailable.length > 0) {
        let localFilteredSubMaterial = subMaterial.filter((item) =>
          supplierResponse.data.materialsAvailable.some(
            (material) => material.materialId === item.masterMaterialId
          )
        );
        setFilteredSubmaterial(localFilteredSubMaterial);
        let localFilteredSurfaceTreatment = surfaceTreatment.filter((item) =>
          supplierResponse.data.materialsAvailable.some((material) =>
            item?.materialMasters?.includes(material.materialId)
          )
        );
        setFiltertedSurfaceTreatment(localFilteredSurfaceTreatment);
      }
    }
  };

  const [supplierValue, setSupplierValue] = useState({
    companyName: "",
    vatNumber: "",
    currency: "",
    bankDetails: {
      bankName: "",
      bankAddress: "",
      accountName: "",
      accountNumber: "",
      swiftCode: "",
      iban: "",
      bankAccountCurrency: "",
    },
    status: "Active",
    typeOfServices: [],
    materialsAvailable: [],
    submaterialsAvailable: [],
    surfaceFinishAvailable: [],
    toleranceAvailable: [],
    surfaceTreatmentAvailable: [],
    partMarkingAvaliable: [],
    layerThicknessAvailable: [],
    capacity: {
      machineName: "",
      type: "",
      qty: 0,
      pricePerHour: 0,
    },
    documentations: [],
  });

  const handleSupplierValueChange = (field, value) => {
    setSupplierValue({ ...supplierValue, [field]: value });
  };

  const handleBankDetailsChange = (field, value) => {
    let localBankDetails = supplierValue.bankDetails;
    localBankDetails[field] = value;
    setSupplierValue({ ...supplierValue, bankDetails: localBankDetails });
  };

  const handleTypeOfServicesName = (name) => {
    let localTypesOfServices = supplierValue.typeOfServices;
    const isServiceAlreadySelected = localTypesOfServices.some(
      (service) => service.serviceName === name
    );
    if (isServiceAlreadySelected) {
      localTypesOfServices = localTypesOfServices.filter(
        (item) => item.serviceName != name
      );
    } else {
      localTypesOfServices.push({
        serviceName: name,
        levelOfExpertise: "Beginner",
      });
    }

    setSupplierValue({
      ...supplierValue,
      typeOfServices: localTypesOfServices,
    });
  };

  const handleServiceExpertise = (value, name) => {
    let localTypesOfServices = supplierValue.typeOfServices;
    localTypesOfServices.forEach((item) => {
      if (item.serviceName == name) {
        item.levelOfExpertise = value;
      }
    });
    setSupplierValue({
      ...supplierValue,
      typeOfServices: localTypesOfServices,
    });
  };

  const handleCreateSupplier = async () => {
    try {
      setError("");

      let isValid = validateData();
      if (isValid) {
        let formData = new FormData();
        formData.append("supplierValue", JSON.stringify(supplierValue));
        supplierValue.documentations.forEach((item) => {
          formData.append("uploadedFile", item.uploadedFile);
        });
        console.log("Email List ::", emailList);
        formData.append('emailList', JSON.stringify(emailList));

        let response = await createSupplierCompany(formData, token);
        if (response.data.code == 11000) {
          toast.error("Supplier already exists");
          return;
        }
        if (response.data.errors) {
          if (Object.keys(response?.data?.errors)?.length > 0) {
            toast.error(response?.data?._message);
            return;
          }
        }
        if (response.data.status) {
          toast.success(response.data.message);
          navigate("/admin/supplier-company-master");
        } else {
          toast.error(response.data.message);
        }
      }
    } catch (err) {
      console.log("err", err);
      toast.error("Something went wrong.");
    }
  };

  const handleUpdateSupplier = async () => {
    try {
      setError("");
      let isValid = validateData();
      if (isValid) {
        let formData = new FormData();
        formData.append("supplierValue", JSON.stringify(supplierValue));
        supplierValue.documentations.forEach((item) => {
          formData.append("uploadedFile", item.uploadedFile);
        });
        formData.append('emailList', JSON.stringify(emailList));
        let response = await updateSupplierCompany(formData, token);
        if (response?.data?.data?.code) {
          if (response?.data?.data?.code == 11000) {
            toast.error("Supplier already exists.");
            return;
          }
        }
        if (response.status == 500) {
          toast.error(
            "Something went wrong while updating the supplier company"
          );
          return;
        }
        if (response.status == 200) {
          toast.success(response.data.message);
          navigate("/admin/supplier-company-master");
          return;
        }
      }
    } catch (err) {
      console.log("err", err);
      toast.error("Something went wrong.");
    }
  };



  const validateData = () => {
    // Company Details
    if (!supplierValue.companyName) {
      setError("Company Name is required in Company Details.");
      return false;
    }
    // Payment Term
    if (!supplierValue.paymentTerm) {
      setError("Payment Term is required.");
      return false;
    }
    if (!supplierValue?.address?.addressLineOne) {
      setError("Address Line 1 is required in Company Details.");
      return false;
    }
    if (!supplierValue?.address?.city) {
      setError("City is required in Company Details.");
      return false;
    }
    if (!supplierValue?.address?.country) {
      setError("Country is required in Company Details.");
      return false;
    }

    // Emails
    if (!emailList || emailList.length === 0) {
      setError("At least one email is required in Emails.");
      return false;
    }

    // Bank Details
    if (!supplierValue?.bankDetails?.bankName) {
      setError("Bank Name is required in Tax & Payments.");
      return false;
    }
    if (!supplierValue?.bankDetails?.accountName) {
      setError("Account Name is required in Tax & Payments.");
      return false;
    }

    // Services
    if (!supplierValue.typeOfServices || supplierValue.typeOfServices.length <= 0) {
      setError("At least one service must be selected in Services.");
      return false;
    }


    return true; // All good
  };






  const handleAddDocumentClick = () => {
    let localDocumentations = [...supplierValue.documentations];
    localDocumentations.push(documentObject);
    setSupplierValue({ ...supplierValue, documentations: localDocumentations });
  };

  const handleDocumentNameChange = (event, index) => {
    let localDocumentations = [...supplierValue.documentations];
    localDocumentations[index].documentName = event.target.value;
    setSupplierValue({ ...supplierValue, documentations: localDocumentations });
  };

  const handleDocumentUpload = (event, index) => {
    let localDocumentations = [...supplierValue.documentations];
    localDocumentations[index].uploadedFile = event.target.files[0];
    setSupplierValue({ ...supplierValue, documentations: localDocumentations });
  };

  const handleNextUpdateByDateChange = (event, index) => {
    let localDocumentations = [...supplierValue.documentations];
    localDocumentations[index].nextUpdatedByDate = event.target.value;
    setSupplierValue({ ...supplierValue, documentations: localDocumentations });
  };

  const handleDocumentRemove = (index) => {
    let localDocumentations = [...supplierValue.documentations];
    localDocumentations.splice(index, 1);
    setSupplierValue({ ...supplierValue, documentations: localDocumentations });
  };
  const handleDocumentFileRemove = async (index) => {
    // confirm deletion with user
    const confirmed = await new Promise((resolve) => {
      AntModal.confirm({
        title: 'Are you sure',
        content: 'Are you sure you want to delete this file?',
        okText: 'Yes',
        cancelText: 'No',
        onOk: () => resolve(true),
        onCancel: () => resolve(false),
      });
    });
    if (!confirmed) return;
    
    let localDocumentations = [...supplierValue.documentations];
    localDocumentations[index].uploadedFile = null;
    setSupplierValue({ ...supplierValue, documentations: localDocumentations });
  };
   


  return (
    <div
      className="admin-container"
      style={{
        width: "100%",
        overflowX: "auto",
        backgroundColor: "#f4e6dd",
        minHeight: "100vh",
      }}
    >
      <Sidebar />
      <div className="admin-panel-container">
        <h1 className="center-heading font-bold text-xl  my-2">
          {_id ? "Edit" : "Add"} Supplier Company
        </h1>
        <div className="edit-company-container">
          <Accordion>
            <Accordion.Item eventKey="0">
              <Accordion.Header>
                <div className="req-box">
                  <h6>Company Details</h6>
                </div>
              </Accordion.Header>
              <Accordion.Body>
                <div className="show-accordiion ">
                  <div>
                    <label htmlFor="companyName">Supplier Company Name </label>:
                    &nbsp;
                    <input
                      name="companyName"
                      type="text"
                      placeholder="Enter company name"
                      value={supplierValue.companyName}
                      onChange={(e) => {
                        handleSupplierValueChange(
                          "companyName",
                          e.target.value
                        );
                      }}
                    />
                  </div>

                  <div>
                    <label htmlFor="supplierRefId">Supplier Ref ID </label>:
                    &nbsp;
                    <input
                      name="supplierRefId"
                      type="text"
                      placeholder="Enter Ref Id"
                      value={supplierValue.supplierRefId}
                      disabled={true}
                    />
                  </div>

                  <div>
                    <label htmlFor="compamy-status">Supplier Status</label>:
                    &nbsp;
                    <input
                      name="company-status"
                      type="radio"
                      value="Active"
                      checked={supplierValue.status == "Active"}
                      onChange={(e) => {
                        handleSupplierValueChange("status", e.target.value);
                      }}
                    />
                    Active
                    <input
                      name="company-status"
                      type="radio"
                      value="Inactive"
                      checked={supplierValue.status == "Inactive"}
                      onChange={(e) => {
                        handleSupplierValueChange("status", e.target.value);
                      }}
                    />
                    Inactive
                  </div>

                  <div>
                    <label htmlFor="vatNumber">Tax Number</label>: &nbsp;
                    <input
                      name="vatNumber"
                      type="text"
                      placeholder="Enter company Tax Number"
                      value={supplierValue.vatNumber}
                      onChange={(e) => {
                        handleSupplierValueChange("vatNumber", e.target.value);
                      }}
                    />
                  </div>
                  <div>
                    <label htmlFor="currency">Currency </label>: &nbsp;
                    <select
                      defaultValue={
                        supplierValue.currency ? supplierValue.currency : ""
                      }
                      value={
                        supplierValue.currency
                          ? supplierValue.currency
                          : "default"
                      }
                      onChange={(e) =>
                        handleSupplierValueChange("currency", e.target.value)
                      }
                    >
                      <option value="usd">USD </option>
                      <option value="eur">EURO </option>
                    </select>
                  </div>

                  <div>
                    <label htmlFor="paymentTerm">Payment Term </label>: &nbsp;
                    <input
                      name="paymentTerm"
                      type="number"
                      placeholder="Enter payment term"
                      value={supplierValue.paymentTerm}
                      onChange={(e) => {
                        handleSupplierValueChange(
                          "paymentTerm",
                          e.target.value
                        );
                      }}
                    />
                  </div>

                  <div>
                    <label htmlFor="addressLineOne">Address Line 1</label>:
                    &nbsp;
                    <input
                      name="addressLineOne"
                      type="text"
                      placeholder="Enter Address Line 1"
                      value={supplierValue?.address?.addressLineOne}
                      onChange={(e) =>
                        setSupplierValue({
                          ...supplierValue,
                          address: {
                            ...supplierValue.address,
                            addressLineOne: e.target.value,
                          },
                        })
                      }
                    />
                  </div>
                  <div>
                    <label htmlFor="addressLineTwo">Address Line 2</label>:
                    &nbsp;
                    <input
                      name="addressLineTwo"
                      type="text"
                      placeholder="Enter Address Line 2"
                      value={supplierValue?.address?.addressLineTwo}
                      onChange={(e) =>
                        setSupplierValue({
                          ...supplierValue,
                          address: {
                            ...supplierValue.address,
                            addressLineTwo: e.target.value,
                          },
                        })
                      }
                    />
                  </div>

                  <div>
                    <label htmlFor="postalCode">Postal Code</label>: &nbsp;
                    <input
                      name="postalCode"
                      type="text"
                      placeholder="Enter Postal Code"
                      value={supplierValue?.address?.postalCode}
                      onChange={(e) =>
                        setSupplierValue({
                          ...supplierValue,
                          address: {
                            ...supplierValue.address,
                            postalCode: e.target.value,
                          },
                        })
                      }
                    />
                  </div>

                  <div>
                    <label htmlFor="city">City</label>: &nbsp;
                    <input
                      name="city"
                      type="text"
                      placeholder="Enter City"
                      value={supplierValue?.address?.city}
                      onChange={(e) =>
                        setSupplierValue({
                          ...supplierValue,
                          address: {
                            ...supplierValue.address,
                            city: e.target.value,
                          },
                        })
                      }
                    />
                  </div>

                  <div>
                    <label htmlFor="state">State</label>: &nbsp;
                    <input
                      name="state"
                      type="text"
                      placeholder="Enter State"
                      value={supplierValue?.address?.state}
                      onChange={(e) =>
                        setSupplierValue({
                          ...supplierValue,
                          address: {
                            ...supplierValue.address,
                            state: e.target.value,
                          },
                        })
                      }
                    />
                  </div>

                  <div>
                    <label htmlFor="country">Country</label>: &nbsp;
                    <input
                      name="country"
                      type="text"
                      placeholder="Enter country"
                      value={supplierValue?.address?.country}
                      onChange={(e) =>
                        setSupplierValue({
                          ...supplierValue,
                          address: {
                            ...supplierValue.address,
                            country: e.target.value,
                          },
                        })
                      }
                    />
                  </div>

                  <div style={{ display: "flex", width: "100%" }}>
                    <label htmlFor="phoneNumber">Phone Number </label>: &nbsp;
                    <div style={{ flexGrow: 2 }}>
                      <PhoneInput
                        placeholder="Enter phone number"
                        name="phone"
                        inputStyle={{ width: "100%" }}
                        containerStyle={{ width: "49%" }}
                        value={`${supplierValue?.address?.phoneNo
                          ? supplierValue?.address?.phoneNo
                          : ""
                          }`}
                        onChange={(val) =>
                          setSupplierValue({
                            ...supplierValue,
                            address: { ...supplierValue.address, phoneNo: val },
                          })
                        }
                      />
                    </div>
                  </div>
                </div>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="1">
              <Accordion.Header>
                <div className="req-box">
                  <h6>Contact Information</h6>
                </div>
              </Accordion.Header>
              <Accordion.Body>
                <div className="flex flex-col gap-6 show-accordiion">

                  {/* Input + Dropdown */}
                  <div className="flex flex-wrap items-center gap-4">
                    <input
                      value={emailInput}
                      onChange={(e) => setEmailInput(e.target.value)}
                      className="px-3 py-2 w-72 border border-gray-300 rounded-md text-gray-800 bg-white"
                      placeholder="Enter email"
                    />
                    <select
                      value={selectedLabel}
                      onChange={(e) => setSelectedLabel(e.target.value)}
                      className="px-3 py-2 border border-gray-300 rounded-md text-gray-800 bg-white"
                    >
                      <option value="RFQ">RFQ</option>
                      <option value="Offer">Offer</option>
                      <option value="PO">PO</option>
                      <option value="All">All</option>
                    </select>
                    <>
                      <button
                        onClick={() => {
                          const trimmed = emailInput.trim();

                          if (!trimmed) {
                            setInputError("Email is required.");
                            return;
                          }

                          if (!validateEmail(trimmed)) {
                            setInputError("Invalid email format.");
                            return;
                          }

                          const alreadyExists = emailList.some(
                            (e) => e.email === trimmed && e.label === selectedLabel
                          );

                          if (alreadyExists) {
                            setInputError("This email is already added.");
                            return;
                          }
                          if (selectedLabel === "All") {
                            //add email in all group
                            setEmailList([...emailList, { label: "RFQ", email: trimmed }, { label: "Offer", email: trimmed }, { label: "PO", email: trimmed }]);
                          }
                          else {
                            setEmailList([...emailList, { label: selectedLabel, email: trimmed }]);

                          }

                          setEmailInput("");
                          setInputError(""); // clear any error
                        }}
                        className="bg-complementaryPrimaryColor text-white text-sm px-5 py-2 rounded-md hover:opacity-90"
                      >
                        Add
                      </button>

                      {inputError && (
                        <p className="text-sm text-red-500 mt-1">{inputError}</p>
                      )}
                    </>

                  </div>

                  {/* Email List Grid */}
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    {["RFQ", "Offer", "PO"].map((group) => {
                      const groupEmails = emailList.filter((item) => item.label === group);
                      return (
                        <div key={group} className="bg-white border border-gray-200 rounded-md p-4">
                          <h6 className="font-semibold text-gray-700 mb-2">{group} Emails</h6>
                          {groupEmails.length === 0 ? (
                            <p className="text-sm text-gray-500">No {group} emails</p>
                          ) : (
                            <ol className="list-decimal  space-y-2">
                              {groupEmails.map((item, index) => (
                                <li
                                  key={index}
                                  className="flex justify-between items-center text-sm text-gray-800"
                                >
                                  <span className="break-words w-full pr-2">{item.email}</span>
                                  <button
                                    onClick={() =>
                                      setEmailList(emailList.filter(
                                        (_, i) =>
                                          i !== emailList.findIndex(
                                            (e) => e.label === item.label && e.email === item.email
                                          )
                                      ))
                                    }
                                    className="text-red-500 hover:text-red-600"
                                  >
                                    <DeleteIcon />
                                  </button>
                                </li>
                              ))}
                            </ol>
                          )}
                        </div>
                      );
                    })}
                  </div>

                </div>
              </Accordion.Body>
            </Accordion.Item>


            <Accordion.Item eventKey="2">
              <Accordion.Header>
                <div className="req-box">
                  <h6>Tax & Payments</h6>
                </div>
              </Accordion.Header>
              <Accordion.Body>
                <div className="show-accordiion">
                  <div>
                    <label htmlFor="bankName">Bank Name </label>: &nbsp;
                    <input
                      name="bankName"
                      type="text"
                      placeholder="Enter Bank Name"
                      value={supplierValue.bankDetails.bankName}
                      onChange={(e) => {
                        handleBankDetailsChange("bankName", e.target.value);
                      }}
                    />
                  </div>
                  <div>
                    <label htmlFor="bankAddress">Bank Address </label>: &nbsp;
                    <input
                      name="bankAddress"
                      type="text"
                      placeholder="Enter Bank Address"
                      value={supplierValue.bankDetails.bankAddress}
                      onChange={(e) => {
                        handleBankDetailsChange("bankAddress", e.target.value);
                      }}
                    />
                  </div>
                  <div>
                    <label htmlFor="accountName">Account Name </label>: &nbsp;
                    <input
                      name="accountName"
                      type="text"
                      placeholder="Enter Account Name"
                      value={supplierValue.bankDetails.accountName}
                      onChange={(e) => {
                        handleBankDetailsChange("accountName", e.target.value);
                      }}
                    />
                  </div>
                  <div>
                    <label htmlFor="accountNumber">Account Number </label>: &nbsp;
                    <input
                      name="accountNumber"
                      type="number"
                      placeholder="Enter Account Number"
                      onWheel={numberInputOnWheelPreventChange}
                      onKeyDown={(e) =>
                        ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()
                      }
                      value={supplierValue.bankDetails.accountNumber}
                      onChange={(e) => {
                        handleBankDetailsChange("accountNumber", e.target.value);
                      }}
                    />
                  </div>
                  <div>
                    <label htmlFor="swiftCode">Swift Code </label>: &nbsp;
                    <input
                      name="swiftCode"
                      type="text"
                      placeholder="Enter Swift Code"
                      value={supplierValue.bankDetails.swiftCode}
                      onChange={(e) => {
                        handleBankDetailsChange("swiftCode", e.target.value);
                      }}
                    />
                  </div>
                  <div>
                    <label htmlFor="iban">IBAN</label>: &nbsp;
                    <input
                      name="iban"
                      type="text"
                      placeholder="Enter IBAN"
                      value={supplierValue.bankDetails.iban}
                      onChange={(e) => {
                        handleBankDetailsChange("iban", e.target.value);
                      }}
                    />
                  </div>
                  <div>
                    <label htmlFor="bankCurrency">Bank Currency</label>: &nbsp;
                    <select
                      name="bankCurrency"
                      defaultValue={
                        supplierValue.bankDetails.bankAccountCurrency
                          ? supplierValue.bankDetails.bankAccountCurrency
                          : "default"
                      }
                      value={
                        supplierValue.bankDetails.bankAccountCurrency
                          ? supplierValue.bankDetails.bankAccountCurrency
                          : "default"
                      }
                      onChange={(e) =>
                        handleBankDetailsChange(
                          "bankAccountCurrency",
                          e.target.value
                        )
                      }
                    >
                      <option disabled value="default">
                        Select a currency
                      </option>
                      {/* <option value="eur">EUR </option> */}
                      <option value="usd">USD </option>
                    </select>
                  </div>
                </div>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="3">
              <Accordion.Header>
                <div className="req-box">
                  <h6>Documentation</h6>
                </div>
              </Accordion.Header>
              <Accordion.Body>
                <div className="show-accordiion">
                  <button
                    className="req-quote-btn"
                    style={{ float: "right", marginBottom: "10px" }}
                    onClick={handleAddDocumentClick}
                  >
                    Add Document
                  </button>
                  <table className="qoute-version-table">
                    <thead>
                      <tr className="heading-row" style={{ height: "40px" }}>
                        <th>Document Name</th>
                        <th>Uploaded File</th>
                        <th>Date Uploaded</th>
                        <th>Action</th>
                        <th>Next Updated By Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      {supplierValue?.documentations?.map((item, i) => {
                        return (
                          <tr key={i}>
                            <td
                              style={{
                                textAlign: "left",
                                wordWrap: "break-word",
                                wordBreak: "break-all",
                                whiteSpace: "normal",
                                width: "300px",
                                paddingLeft: "20px",
                              }}
                            >
                              <input
                                style={{ width: "95%" }}
                                value={item.documentName}
                                onChange={(e) => handleDocumentNameChange(e, i)}
                                placeholder="Enter document name"
                              />{" "}
                              <img />
                            </td>
                            <td
                              style={{
                                textAlign: "left",
                                wordWrap: "break-word",
                                wordBreak: "break-all",
                                whiteSpace: "normal",
                                width: "300px",
                                paddingLeft: "20px",
                              }}
                            >
                              <div className="quality-doc-div">
                                {item?.uploadedFile?.originalname ||
                                  item?.uploadedFile?.fileName ||
                                  item?.uploadedFile?.name ? (
                                  <>
                                    {item?.uploadedFile?.name ? (
                                      <div className="flex items-center gap-x-2">
                                        <a
                                          className="downloadables"
                                          href={URL.createObjectURL(
                                            item?.uploadedFile
                                          )}
                                          download={item?.uploadedFile?.name}
                                        >
                                          <span>
                                            {item?.uploadedFile?.originalname ||
                                              item?.uploadedFile?.fileName ||
                                              item?.uploadedFile?.name}
                                          </span>

                                        </a>
                                        <a
                                          href={URL.createObjectURL(
                                            item?.uploadedFile
                                          )}
                                          download={item?.uploadedFile?.name}

                                        >
                                          <DownloadIcon />
                                        </a>
                                        <div
                                          onClick={() =>
                                            handleDocumentFileRemove(i)
                                          }

                                        >
                                          <DeleteIcon
                                            additionalClasses={'text-red-500'}
                                          />
                                        </div>
                                      </div>
                                    ) : (
                                      <>
                                        <span className="downloadables flex justify-center items-center gap-x-2">
                                          <span
                                          >
                                            {item?.uploadedFile?.originalname ||
                                              item?.uploadedFile?.fileName ||
                                              item?.uploadedFile?.name}
                                          </span>
                                          &nbsp; &nbsp;
                                        </span>
                                        <div
                                          onClick={() => {
                                            downloadFileFromS3(item?.uploadedFile)
                                          }
                                          }
                                        >
                                          <DownloadIcon />
                                        </div>
                                        <div
                                          onClick={() =>
                                            handleDocumentFileRemove(i)
                                          }

                                        >
                                          <DeleteIcon
                                            additionalClasses={'text-red-500'}
                                          />
                                        </div>
                                      </>
                                    )}
                                  </>
                                ) : (
                                  <div>
                                    <label
                                      className="white-btn"
                                      htmlFor={`upload${i}`}
                                    // style={{
                                    //   width: "80%",
                                    //   textAlign: "center",
                                    // }}
                                    >
                                      Upload File &nbsp;{" "}
                                      <img
                                        style={{ cursor: "pointer" }}
                                        alt="delete"
                                        //   height="15px"
                                        className="h-4"
                                        src={uploadImage}
                                      />
                                    </label>
                                    <input
                                      id={`upload${i}`}
                                      className="quality-doc-item-input"
                                      type="file"
                                      onChange={(e) => {
                                        let filesForCheck = Array.from(
                                          e.target.files
                                        );
                                        let isAllFilesValid = true;
                                        filesForCheck.forEach((file) => {
                                          if (file.size > 1058816) {
                                            isAllFilesValid = false;
                                          }
                                        });

                                        if (!isAllFilesValid) {
                                          toast.error(
                                            "File size should be less than 10 MB"
                                          );
                                          return;
                                        }
                                        handleDocumentUpload(e, i);
                                      }}
                                      accept="image/jpeg,image/gif,image/png,application/pdf,image/x-eps"
                                    />
                                  </div>
                                )}
                              </div>
                            </td>
                            <td>
                              {moment(item?.dateUploaded).format("MMM DD, YYYY")}                          </td>
                            <td
                            // style={{
                            //   textAlign: "center",
                            //   wordWrap: "break-word",
                            //   wordBreak: "break-all",
                            //   whiteSpace: "normal",
                            //   width: "300px",
                            //   paddingLeft: "20px",
                            // }}
                            >
                              <button
                                className="white-btn text-red-500"

                                onClick={() => handleDocumentRemove(i)}
                              >
                                Delete Document&nbsp;{" "}
                                <DeleteIcon
                                  additionalClass={'!text-red-500'}
                                />
                              </button>
                            </td>
                            <td>
                              <input
                                type="date"
                                value={
                                  item.nextUpdatedByDate
                                    ? new Date(item.nextUpdatedByDate)
                                      .toISOString()
                                      .slice(0, 10)
                                    : ""
                                }
                                min={new Date().toISOString().split("T")[0]}
                                onChange={(e) =>
                                  handleNextUpdateByDateChange(e, i)
                                }
                              />
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="4">
              <Accordion.Header>
                <div className="req-box">
                  <h6>Services</h6>
                </div>
              </Accordion.Header>
              <Accordion.Body>
                <div className="show-accordiion">
                  <div>
                    <label htmlFor="type-of-services">
                      <h6>Types of Services</h6>
                    </label>
                    : &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
                    <span style={{ textAlign: "right" }}>
                      Level Of Service Expertise
                    </span>
                    {processType.map((item, i) => {
                      if (i < processType.length - 3) {
                        return (
                          <div className="type-of-services-div " key={i}>
                            <div
                              className={
                                supplierValue.typeOfServices.some(
                                  (service) => service.serviceName == item.name
                                )
                                  ? "box-pr pr-checked"
                                  : "box-pr"
                              }
                              onClick={() => handleTypeOfServicesName(item.name)}
                            >
                              <div className="pr-radio">
                                <label className="btn box-in" htmlFor="btnradio5">
                                  <span className="triangle-0">
                                    {" "}
                                    <img src={tickwhite} />
                                  </span>
                                  <span>{item.name}</span>
                                </label>
                              </div>
                            </div>
                            <div>
                              <input
                                name={item.name}
                                type="radio"
                                value={"Beginner"}
                                checked={supplierValue.typeOfServices.some(
                                  (service) =>
                                    service.serviceName === item.name &&
                                    service.levelOfExpertise == "Beginner"
                                )}
                                disabled={
                                  !supplierValue.typeOfServices.some(
                                    (service) => service.serviceName === item.name
                                  )
                                }
                                onChange={(e) =>
                                  handleServiceExpertise(
                                    e.target.value,
                                    item.name
                                  )
                                }
                              />
                              Beginner
                              <input
                                name={item.name}
                                type="radio"
                                value="Intermediate"
                                checked={supplierValue.typeOfServices.some(
                                  (service) =>
                                    service.serviceName === item.name &&
                                    service.levelOfExpertise == "Intermediate"
                                )}
                                disabled={
                                  !supplierValue.typeOfServices.some(
                                    (service) => service.serviceName === item.name
                                  )
                                }
                                onChange={(e) =>
                                  handleServiceExpertise(
                                    e.target.value,
                                    item.name
                                  )
                                }
                              />
                              Intermediate
                              <input
                                name={item.name}
                                type="radio"
                                value="Expert"
                                checked={supplierValue.typeOfServices.some(
                                  (service) =>
                                    service.serviceName === item.name &&
                                    service.levelOfExpertise == "Expert"
                                )}
                                disabled={
                                  !supplierValue.typeOfServices.some(
                                    (service) => service.serviceName === item.name
                                  )
                                }
                                onChange={(e) =>
                                  handleServiceExpertise(
                                    e.target.value,
                                    item.name
                                  )
                                }
                              />
                              Expert
                            </div>
                          </div>
                        );
                      }
                    })}
                  </div>
                </div>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
          <br />
          {_id ? (
            <>
              <div className="center-heading">
                <button
                  className="button-search supplierButton"
                  onClick={handleUpdateSupplier}
                >
                  {" "}
                  Update Supplier Company{" "}
                </button>
              </div>
            </>
          ) : (
            <>
              <div className="center-heading">
                <button
                  className="button-search supplierButton"
                  onClick={handleCreateSupplier}
                >
                  {" "}
                  Create Supplier Company{" "}
                </button>
              </div>
            </>
          )}

          {error ? (
            <div
              style={{
                color: "red",
                fontSize: "15px",
                textAlign: "center",
                marginTop: "10px",
              }}
            >
              {error}
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default AddSupplierCompany;
